(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.bg = {
    attach: function (context, settings) {
      once('bg', '*[data-bg]', context).forEach(function (block) {
        var bg = $(block).data('bg');
        if (bg.substr(0, 1) === '#') {
          $(block).css({
            'background-color': bg
          });
        } else {
          $(block).css({
            'background-image': 'url(' + bg + ')'
          });
        }
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
